import React from 'react';
import cn from 'classnames';
import Container from 'components/UI/Container';
import Title from 'components/UI/Title';
import Subtitle from 'components/UI/Subtitle';
import Link from 'components/UI/Link';
import InsightsVideo from './InsightsVideo';
import ExpertTalks from './ExpertTalks';
import PinnedContent from './PinnedContent';
import { useTrans } from 'utils/localisation';
import { withErrorBoundary } from 'components/ErrorBoundary';

import * as styles from './Insights.module.scss';

function Insights({ title, description, filterByCategory, videoIdArray, pinnedContent, theme }) {
  const t = useTrans(['insights']);
  const isThemeDark = theme === 'dark';
  const textColor = isThemeDark ? 'white' : 'black';

  return (
    <Container
      id="insights"
      background={isThemeDark ? 'transparent' : 'white'}
      className={cn(styles.container, isThemeDark && styles.dark)}
    >
      <div className={styles.wrapper}>
        <Title tag="h2" color={textColor}>
          {title ?? t('title')}
        </Title>
        <Subtitle size="lg" color={textColor}>
          {description ?? t('description')}
        </Subtitle>
        <section>
          <InsightsVideo theme={theme} videoIdArray={videoIdArray} />
        </section>
        <div className={styles.bottomContent}>
          <ExpertTalks filterByCategory={filterByCategory} isThemeDark={isThemeDark} />
          <PinnedContent items={pinnedContent} isThemeDark={isThemeDark} />
        </div>
        <div className={cn(styles.linkRow, isThemeDark && styles.dark)}>
          <Link href="/company/insights" className={styles.link}>
            {t('seeAllInsights')}
          </Link>
        </div>
      </div>
    </Container>
  );
}

Insights.displayName = 'Insights';

export default withErrorBoundary(Insights);
